import React from "react";
import Img from "./basic/Img";
import Cursor from "./basic/Cursor";

function Contact() {
    return (
        <div className="contact">
            <div className="contact-body-wrap">
                <Img
                    fileName={"contactBody"}
                    className={"contact-body-image"}
                />
                <div className="contact-body-greenback">
                    <a
                        href="mailto:pr@bunshun.co.jp"
                        onClick={() => {
                            gtag("event", "click", {
                                event_category: "mail",
                                event_label: "mailaddress",
                            });
                        }}
                    >
                        <Img
                            fileName={"contactLink"}
                            className={"contact-body-link"}
                        />
                    </a>
                </div>
                <Cursor setClass="contact-cursor" setImage="cursor" />
            </div>
        </div>
    );
}

export default Contact;
